// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://dev.sharaniponguru.me/api/',
  imageBasePath: 'https://dev.sharaniponguru.me/api/static',
  sessionEncKey: '1a2b3c4d5e6f708192a3b4c5d6e7f8012a3b4c5d6e7f8091a2b3c4d5e6f70819',
  siteUrl: 'https://dev.sharaniponguru.me/',
  prodUrl: 'https://sharaniponguru.me/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
